"use strict";

import angular from "angular";

angular.module("nucont.accounting.batchImport", ["nucont.shared"]);
require("./batch-import.routes");
